import React, { FunctionComponent, HTMLAttributes, useEffect } from 'react';
import { CommonColorType } from '../../styles/common-color-type';
import styles from './card-component.module.scss';

type CardProps = {
  shadow?: 'none' | 'sm' | 'md' | 'lg';
  cardTitle?: string;
  titleClassName?: string;
  /**
   * @deprecated This prop should not be used; use radius prop
   */
  /**
   * deprecated -> This prop should not be used; use radius prop
   */
  squareCorners?: boolean;
  radius?: 0 | 4 | 8 | string;
  /**
   *  'black' | 'grey' | 'white' | '#ffffff'| 'rsRed'| 'highlightRed' | 'midtoneRed'  | 'shadowRed'| 'transparent' | string
   */
  backgroundColor?: CommonColorType | 'transparent' | string;
  backgroundOpacity?: number;
  padding?: boolean;
} & HTMLAttributes<HTMLElement>;

/**
 * Card component - text, icon, icon & text
 *
 * https://www.figma.com/file/jiN4FkdkhDZIWxIkPS6Ru7/design-system?node-id=46%3A0
 */
export const Card: FunctionComponent<CardProps> = ({
  shadow = 'none',
  cardTitle = undefined,
  titleClassName = '',
  squareCorners = false,
  radius = undefined,
  backgroundColor = 'white',
  backgroundOpacity = 100,
  padding = true,
  className,
  children,
  ...divAttributes
}) => {
  let cornerClass: string = '';
  if (!squareCorners) cornerClass = styles['corner-round'];

  useEffect(() => {
    if (backgroundOpacity) {
      document.documentElement.style.setProperty('--background-opacity', backgroundOpacity + '%');
    }
  }, [backgroundOpacity]);

  useEffect(() => {
    if (radius !== undefined) {
      const radiusString = radius.toString();
      document.documentElement.style.setProperty(
        '--corner-radius',
        radiusString === '4' || radiusString === '8' || radiusString === '0' ? radiusString + 'rem' : radiusString
      );

      if (squareCorners) {
        throw new TypeError('You cannot have squareCorners set to true and a radius value at the same time!');
      }
    }
  }, [radius, squareCorners]);

  return (
    <div
      className={`${styles['card-component']} 
        ${shadow !== 'none' ? styles[`shadow-${shadow}`] : ''}
         ${radius === undefined ? cornerClass : styles['card-radius']} ${className ?? ''} ${padding ? styles.padding : ''} ${
        backgroundColor ? styles[backgroundColor.replace('#', '')] : ''
      }`}
      {...divAttributes}
    >
      {cardTitle ? <p className={`${styles.title} ${titleClassName ?? ''}`}>{cardTitle}</p> : null}
      {children}
    </div>
  );
};

export default Card;
